import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 29.1vw;
  height: 52.62em;
  font-size: 12px;
  background: #fffff;
  position: relative;

  .hide {
    display: none;
  }
  
  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .logo-rodape {
    width: 10em;
    position: absolute;
    top: 49.3em;
    left: 1.5em;
  }

  .barra-sup {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
  }

  .barra-sup3 {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
    position: absolute;
    top: 51.45em;
    left: 25.2em;
  }

  .barra-sup2 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    top: 0;
    left: 12em;
    position: absolute;
  }

  .barra-sup4 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    position: absolute;
    top: 51.85em;
    left: 16.19em;
  }

  .header {
    margin-top: -2em;
    padding: 1.6em;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .titulo {
        font-size: 9px;
        color: #5B5A5A;
        font-weight: 600;
      }

      .titulo-data {
        font-size: 9px;
        color: #A4A2A2;
      }
    }
  }
  
  .body {
    padding: 0.5em 3em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 40em;

    .mid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      height: 18em;

      .text {
        margin-top: 1.5em;
      }

      .tit {
        color: #5B5A5A;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 1em;
      }

      .titulo {
        color: #5B5A5A;
        font-size: 13px;
        font-weight: 600;
      }
    }
    
    .bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 24vw;

      .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 24vw;
        min-height: 4rem;
        background: #1E4778;
        border-radius: 1rem;
        padding: 1rem;

        .titulo {
          font-size: 10px;
          color: #fff;
          font-weight: 600;
        }
      }
    }
  }

`;


export const Complemento = styled.div`
  content: "";
  width: 100%;
  background: #FFFFFF;

  ${props => {
    return `height: ${props?.height}px;`;
  }}
`